import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useGetGeoScopeForCurrentUser from 'hooks/useGetGeoScopeForCurrentUser';

const GeoRestrictionAlert = ({ scopeType = 'geographic scope' }) => {
  const { t } = useTranslation('enterprises');
  const { geoScope } = useGetGeoScopeForCurrentUser();
  const scopeLevel = geoScope?.data?.scopeLevel;
  const { regions, departments, arrondissements } = geoScope?.data || {};

  return (
    <Alert
      severity="error"
      className="m-[55px] border-2 border-red-500 flex flex-col items-center justify-center"
    >
      <AlertTitle className="text-lg font-bold uppercase text-red-700">
        {t('error_geo_restriction_title') || 'Restriction Géographique'}
      </AlertTitle>
      <div className="flex flex-col gap-4 mt-4 items-center justify-center">
        <p className="text-sm font-medium text-gray-800">
          {t('error_geo_restriction_message') ||
            `Vous avez tenté d'accéder à ${scopeType} en dehors de votre portée autorisée.`}
        </p>

        <div className="bg-white p-3 rounded border border-red-200">
          <p className="text-sm font-bold uppercase text-red-600 mb-3">
            {t('allowed') || 'Autorisé'} {scopeLevel && `(${scopeLevel.toUpperCase()})`}
          </p>

          <div className="space-y-2 text-sm">
            {regions && regions.length > 0 && (
              <div className="pl-3 border-l-4 border-red-300">
                <p className="font-semibold text-gray-700 uppercase">{t('regions') || 'Régions'}</p>
                <p className="text-gray-600 ml-2">{regions.map((r) => r.name).join(', ')}</p>
              </div>
            )}
            {departments && departments.length > 0 && (
              <div className="pl-3 border-l-4 border-orange-300">
                <p className="font-semibold text-gray-700 uppercase">
                  {t('departments') || 'Départements'}
                </p>
                <p className="text-gray-600 ml-2">{departments.map((d) => d.name).join(', ')}</p>
              </div>
            )}
            {arrondissements && arrondissements.length > 0 && (
              <div className="pl-3 border-l-4 border-yellow-300">
                <p className="font-semibold text-gray-700 uppercase">
                  {t('arrondissements') || 'Arrondissements'}
                </p>
                <p className="text-gray-600 ml-2">
                  {arrondissements.map((a) => a.name).join(', ')}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="mt-2 p-3 bg-red-50 rounded border border-red-300">
          <p className="text-sm text-red-800 font-medium">
            <strong>
              ⚠️{' '}
              {t('geo_restriction_contact_admin') ||
                "Si vous pensez que vous devriez avoir accès à ces zones, veuillez contacter votre administrateur pour mettre à jour vos autorisations d'accès géographique."}
            </strong>
          </p>
        </div>
      </div>
    </Alert>
  );
};

export default GeoRestrictionAlert;
